import * as Immutable from 'immutable';
import * as React from 'react';

import { localeData } from '../../../locales/data';

import './ErrorMsg.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface ErrorMsgIntlProps {
  errors: Immutable.List<string>;
}

const ErrorMsgIntl = ({ errors }: ErrorMsgIntlProps) => {
  const errorsIm = Immutable.List.isList(errors) === true ? errors : Immutable.fromJS(errors);
  // @ts-ignore
  const firstMessage = errorsIm.size !== 0 ? errorsIm.first() : null;
  if (firstMessage && typeof firstMessage === 'string') {
    return (
      <div className="error">
        <FormattedMessageHelper tagName="span" id={firstMessage} defaultMessage={localeData.en[firstMessage]} />
      </div>
    );
  } else if (firstMessage && typeof firstMessage === 'object') {
    return (
      <div className="error">
        <FormattedMessageHelper tagName="span" {...(firstMessage as any).toJS()} />
      </div>
    );
  } else {
    return null;
  }
};

export default ErrorMsgIntl;
